// extracted by mini-css-extract-plugin
export default {"r_l":"_587fdcebff c961d27c63","t":"_7a015e0060"};